import React from 'react';
import { Store, Calendar, Compass, Users, MapPin, Map, Crown, Star, User, Download } from 'lucide-react';

export function MarketplaceMockup() {
  const templates = [
    {
      name: 'La Malédiction de Strahd',
      category: 'campaign',
      catColor: 'bg-blue-500/20 text-blue-400',
      difficulty: 'advanced',
      diffColor: 'text-orange-400',
      universe: 'Ravenloft',
      system: 'D&D 5e',
      author: 'WotC Official',
      imports: 342,
      official: true,
      featured: true,
      content: { sessions: 15, quests: 8, npcs: 24, locations: 12, maps: 6 },
      gradient: 'from-purple-900/60 via-red-900/40 to-black/60',
    },
    {
      name: 'Mines Perdues de Phandelver',
      category: 'module',
      catColor: 'bg-purple-500/20 text-purple-400',
      difficulty: 'beginner',
      diffColor: 'text-green-400',
      universe: 'Forgotten Realms',
      system: 'D&D 5e',
      author: 'CommunityGM',
      imports: 891,
      official: false,
      featured: false,
      content: { sessions: 8, quests: 5, npcs: 16, locations: 9, maps: 3 },
      gradient: 'from-emerald-900/60 via-stone-800/40 to-black/60',
    },
    {
      name: 'One-shot : Le Dragon d\'Or',
      category: 'one-shot',
      catColor: 'bg-amber-500/20 text-amber-400',
      difficulty: 'intermediate',
      diffColor: 'text-blue-400',
      universe: 'Custom',
      system: 'D&D 5e',
      author: 'DM_Legends',
      imports: 156,
      official: false,
      featured: false,
      content: { sessions: 1, quests: 2, npcs: 6, locations: 3, maps: 2 },
      gradient: 'from-amber-900/60 via-red-900/40 to-black/60',
    },
  ];

  const contentIcons = { sessions: Calendar, quests: Compass, npcs: Users, locations: MapPin, maps: Map };

  return (
    <div className="landing-mockup-card">
      <div className="flex items-center gap-2 mb-3">
        <Store className="h-4 w-4 text-indigo-400" />
        <span className="font-cinzel text-xs font-bold">Marketplace</span>
        <div className="ml-auto flex gap-1">
          <span className="text-[8px] px-1.5 py-0.5 rounded bg-muted/50 text-muted-foreground">Campagnes</span>
          <span className="text-[8px] px-1.5 py-0.5 rounded bg-muted/50 text-muted-foreground">Modules</span>
          <span className="text-[8px] px-1.5 py-0.5 rounded bg-primary/20 text-primary">Tout</span>
        </div>
      </div>

      <div className="space-y-2">
        {templates.map((tpl, i) => (
          <div key={i} className="rounded-lg border border-border/30 overflow-hidden hover:border-primary/20 transition-colors cursor-pointer group">
            <div className={`h-10 bg-gradient-to-r ${tpl.gradient} relative flex items-end px-2 pb-1`}>
              {tpl.official && (
                <span className="absolute top-1 right-1 text-[7px] px-1.5 py-0.5 rounded-full bg-primary/80 text-primary-foreground font-medium flex items-center gap-0.5">
                  <Crown className="h-2 w-2" /> Official
                </span>
              )}
              {tpl.featured && !tpl.official && (
                <span className="absolute top-1 right-1 text-[7px] px-1.5 py-0.5 rounded-full bg-amber-500/80 text-white font-medium flex items-center gap-0.5">
                  <Star className="h-2 w-2" />
                </span>
              )}
              <span className={`text-[7px] px-1.5 py-0.5 rounded-full ${tpl.catColor}`}>{tpl.category}</span>
            </div>
            <div className="px-2 py-1.5">
              <div className="flex items-center gap-1 mb-0.5">
                <span className="text-[10px] font-cinzel font-bold truncate flex-1 group-hover:text-primary transition-colors">{tpl.name}</span>
                <span className={`text-[7px] ${tpl.diffColor}`}>{tpl.difficulty}</span>
              </div>
              <div className="text-[8px] text-muted-foreground mb-1">{tpl.universe} · {tpl.system}</div>
              <div className="flex gap-2 mb-1">
                {Object.entries(tpl.content).map(([key, val]) => {
                  const Icon = contentIcons[key];
                  return (
                    <span key={key} className="flex items-center gap-0.5 text-[7px] text-muted-foreground">
                      <Icon className="h-2 w-2" />{val}
                    </span>
                  );
                })}
              </div>
              <div className="flex items-center justify-between text-[8px] text-muted-foreground">
                <span className="flex items-center gap-0.5"><User className="h-2 w-2" />{tpl.author}</span>
                <span className="flex items-center gap-0.5"><Download className="h-2 w-2" />{tpl.imports}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
